
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { EmployeeFormData } from "@/types/employee";

interface BasicInfoSectionProps {
  formData: EmployeeFormData;
  setFormData: (data: EmployeeFormData) => void;
}

export const BasicInfoSection = ({ formData, setFormData }: BasicInfoSectionProps) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-slate-800 border-b pb-2">المعلومات الأساسية</h3>
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="name" required>الاسم الكامل *</Label>
          <Input
            id="name"
            value={formData.name}
            onChange={(e) => setFormData({...formData, name: e.target.value})}
            required
            placeholder="الاسم الكامل للموظف"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="email" required>البريد الإلكتروني *</Label>
          <Input
            id="email"
            type="email"
            value={formData.email}
            onChange={(e) => setFormData({...formData, email: e.target.value})}
            required
            placeholder="example@company.com"
          />
        </div>
      </div>
      
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="employee_number">رقم الموظف (اختياري)</Label>
          <Input
            id="employee_number"
            value={formData.employee_number}
            onChange={(e) => setFormData({...formData, employee_number: e.target.value})}
            placeholder="رقم الموظف"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="phone">رقم الهاتف (اختياري)</Label>
          <Input
            id="phone"
            value={formData.phone}
            onChange={(e) => setFormData({...formData, phone: e.target.value})}
            placeholder="+966 50 123 4567"
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="birth_date">تاريخ الميلاد (اختياري)</Label>
          <Input
            id="birth_date"
            type="date"
            value={formData.birth_date}
            onChange={(e) => setFormData({...formData, birth_date: e.target.value})}
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="status">الحالة (اختياري)</Label>
          <Select value={formData.status} onValueChange={(value) => setFormData({...formData, status: value})}>
            <SelectTrigger>
              <SelectValue placeholder="اختر الحالة" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="present">حاضر</SelectItem>
              <SelectItem value="absent">غائب</SelectItem>
              <SelectItem value="late">متأخر</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  );
};
